import React, { createContext, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { router } from "./pages/router";
import { RouterProvider } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import Loader from "./pages/components/animation/Loader";
import ScrollProgress from "./components/scrollProgress/ScrollProgress";
import { useDispatch, useSelector } from "react-redux";
import { setIsShowLoader } from "./store/reducers/loaderReducer";
import MainService from "./helpers/services/mainService";
import { ApiService } from "./helpers/services/apiSrevice";

export const CourseContext = createContext(null);

const App = () => {

  const dispatch = useDispatch();
  const [courses, setCourses] = useState([]);

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    getCourses();
  }, [])

  const getCourses = () => {
    dispatch(setIsShowLoader(true));
    MainService.callApi({
      api: ApiService.getCourses,
      cb: response => {
        if (response && response.data) {
          setCourses([...response.data].sort((a, b) => Number(a.id) - Number(b.id)));
        }
      },
      _finally: () => {
        setTimeout(() => {
          dispatch(setIsShowLoader(false));
        }, 1000);
      }
    });
  }

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  
  return <div style={{ maxWidth: "100vw", overflow: "hidden" }}>
    <CourseContext.Provider value={{
      courses,
      setCourses
    }}>
      <ScrollProgress />
      <RouterProvider router={router()} />
      <ToastContainer theme="dark" autoClose={5000} />
      <Loader />
      {
        scrolled ?
          // <span className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top d-flex" onClick={scrollTop}>
          //   <FaArrowUp />
          // </span>
          <img className="scroll-top" src="/images/scroll-top.svg" onClick={scrollTop}/>
          : null
      }
    </CourseContext.Provider>
  </div>
}
export default App
